import { useEffect, useRef } from "react";

export const useIsCancelledMount = () => {
  const cancelledRef = useRef(false);

  useEffect(() => {
    cancelledRef.current = false;

    return () => {
      cancelledRef.current = true;
    };
  }, []);

  return cancelledRef;
};
